import React from 'react';
import {
  Box,
  Container,
  Typography,
  Stack,
  Divider,
  Paper,
  styled,
} from '@mui/material';
import { YellowBoxBottom } from './Home';
import { ReactComponent as Pricing1 } from '../../assets/images/pricing-1.svg';
import { ReactComponent as Pricing2 } from '../../assets/images/pricing-2.svg';
import { ReactComponent as Pricing3 } from '../../assets/images/pricing-3.svg';
import { PricingContainer } from '../../components/PricingContainer';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#2e2e2e' : '#f7f7f7',
  textAlign: 'left',
  borderRadius: '6px',
  paddingRight: '16px',
  paddingLeft: '16px',
  paddingTop: '12px',
  paddingBottom: '12px',
  fontStyle: 'italic',
}));

const ImageBorderBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.mode === 'dark' ? '#bbb' : '#454545',
}));

export const FeatureCard = ({ title, description, icon, Icon }) => {
  console.log(Icon, typeof Icon);
  return (
    <Box position="relative" display="inline-block" mx="auto">
      {/* Icon floating top-left on border */}
      <ImageBorderBox position="absolute" top={-16} left={-16} zIndex={5}>
        {typeof Icon === 'string' ? (
          <img
            src={icon}
            alt="icon"
            style={{ width: '100%', height: '100%' }}
          />
        ) : (
          <Box component={Icon} sx={{ width: 40, height: 40 }} />
        )}
      </ImageBorderBox>

      {/* Main Card */}
      <Paper
        variant="outlined"
        sx={{
          px: 3,
          pt: 4,
          pb: 3,
          borderRadius: 2,
          bgcolor: 'transparent',
          borderColor: '#bbb',
          maxWidth: 600,
          minHeight: 160,
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" fontWeight={500} mb={2}>
          {title}
        </Typography>

        {/* Quote box */}
        <StyledBox>
          <Typography variant="homePageBody" paragraph>
            {description}
          </Typography>
        </StyledBox>
      </Paper>
    </Box>
  );
};

const PricingDifference = () => {
  const features = [
    {
      title: 'Minimalist Pricing, Maximum Value',
      description:
        'We charge only for what truly matters insightful, tailored answers and expert-backed recommendations. No bloated packages, No hidden charges.',
      icon: Pricing1,
    },
    {
      title: 'Accessible to All',
      description:
        "Our pricing is tailored for everyone whether you're a student, homemaker, entrepreneur, or retiree ensuring affordability without compromising on quality.",
      icon: Pricing2,
    },
    {
      title: 'Affordable Doesn’t Mean Compromised',
      description:
        'Every question you ask receives a deeply researched and astrologically accurate answer, reviewed or trained on guidance from experienced astrologers.',
      icon: Pricing3,
    },
  ];
  return (
    <Box>
      {/* Header Section */}
      <Typography variant="h2">Why Our Pricing is Different</Typography>
      <Typography variant="homePageBody" paragraph>
        In a world flooded with overpriced consultations and vague promises,
        we’ve chosen a different path. Our goal is to deliver precision-led
        astrological guidance backed by advanced AI and ancient wisdom at a
        price that respects your wallet and your trust.
      </Typography>

      {/* Feature Cards */}
      <Stack spacing={6} sx={{ marginTop: 'calc(100px - 36px)' }}>
        {features.map((item, index) => (
          <Stack alignItems="center" key={index} position="relative" px={1}>
            <FeatureCard
              key={index}
              title={item.title}
              description={item.description}
              icon={item.icon}
              Icon={item.icon}
            />
          </Stack>
        ))}
      </Stack>

      <Divider />

      {/* Economy of Trust Section */}
      <Typography variant="h2">We’re Building an Economy of Trust</Typography>
      <Typography variant="homePageBody" paragraph>
        We envision a future where astrology becomes a part of everyday life
        guiding you through health, career, finance, relationships, and
        spiritual evolution. And for that to happen, it has to be affordable,
        dependable, and inclusive.
        <br />
        When you <strong>pay</strong>{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, you’re
        not just buying a service:
      </Typography>
      <Typography variant="homePageBody" paragraph>
        You’re supporting a movement to{' '}
        <strong>democratise Vedic astrology</strong>
        <br />
        You’re investing in an{' '}
        <strong>AI model rooted in sacred knowledge</strong>
        <br />
        And by choosing us, you're supporting the mission to make authentic,{' '}
        <br />
        <strong>
          {' '}
          ethically sourced gemstones and credible astrological tools
        </strong>{' '}
        accessible to all.
      </Typography>
    </Box>
  );
};

const Pricing = () => {
  return (
    <Box>
      <Typography variant="h1" textAlign="center" gutterBottom>
        Pricing
      </Typography>
      <Typography variant="homePageBody" paragraph>
        We believe that authentic{' '}
        <strong>astrological guidance should never be a luxury.</strong> It
        should be accessible to every individual seeking clarity, growth, or
        peace of mind.
        <br />
        That’s why we’ve built a{' '}
        <strong>
          minimalistic, transparent, and value-driven pricing model
        </strong>{' '}
        that reflects our core philosophy:{' '}
        <strong>empowerment over exploitation.</strong>
      </Typography>

      <Typography
        variant="h3"
        fontWeight={500}
        sx={{ marginBottom: '100px' }}
        textAlign="center"
      >
        Transparent. Thoughtful. Truly Affordable.
      </Typography>
      <PricingContainer />
      <Divider />
      <PricingDifference />
      <YellowBoxBottom>
        <Typography variant="h3" fontWeight="600" gutterBottom>
          ✨ Clarity shouldn't cost a fortune it should <br /> light the path
          forward.
        </Typography>
        <Typography variant="homePageBody" paragraph>
          Choose wisely. Spend consciously. Grow endlessly with{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>.
        </Typography>
      </YellowBoxBottom>
    </Box>
  );
};

export default Pricing;
